import Gameboard from "./Components/Gameboard";
import Navbar from "./Components/Navbar";
import Rules from "./Components/Rules";
import Footer from "./Components/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Rules />
      <Gameboard />
      <Footer />
    </div>
  );
}

export default App;
